import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from "react-big-calendar";
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography,
    Grid
} from '@mui/material';
import DatePicker, { registerLocale } from 'react-datepicker';
import it from "date-fns/locale/it";
import moment from 'moment';
import 'moment/locale/it';

import "react-big-calendar/lib/css/react-big-calendar.css";
import 'react-datepicker/dist/react-datepicker.css';

const localizer = momentLocalizer(moment);
const themeColor = '#a71e3b';

function SchedulerLab(props) {
    const [showModal, setShowModal] = useState(false);
    const [dtStartEvent, setDtStartEvent] = useState();
    const [dtEndEvent, setDtEndEvent] = useState();
    const [scheduleType, setscheduleType] = useState("");
    const [titleEvent, settitleEvent] = useState("");
    const [localEvents, setLocalEvents] = useState([]);
    const [dtInitialStartEvent, setInitialDtStartEvent] = useState();
    const [dtInitialEndEvent, setInitialDtEndEvent] = useState();

    const {
        baseImage,
        labEvents,
        defaultView,
        email,
        isSubmitted,
        setIsSubmitble,
        setLabEvents,
        defaultDate
    } = props;

    registerLocale("it", it);

    useEffect(() => {
        var usageData;
        const evtArray = [];
        var mySchedule = [];

        usageData = baseImage.usageData;

        if (labEvents.length === 0) {
            mySchedule = usageData.schedulerLab;
            console.log("mySchedule usagedata: ", mySchedule);
        } else {
            mySchedule = labEvents;
            console.log("mySchedule labEvents: ", mySchedule);
        }

        mySchedule.forEach(element => {
            let myTitle = "";
            let myColor = "";

            if (defaultView === "day") {
                myTitle = 'idLab: ' + element.idLab + ', ' +
                    ' labName: ' + element.labName + ', ' +
                    ' destId: ' + element.destinationId + ', ' +
                    ' teacher: ' + element.teacher.email;
            } else {
                myTitle = element.teacher.email;
            }

            if (element.scheduleType === "easy") {
                myColor = "red";
            } else {
                myColor = "#3174ad";
            }

            var a = {
                title: myTitle,
                start: moment(element.start).toDate(),
                end: moment(element.end).toDate(),
                teacher: element.teacher.email,
                scheduleType: element.scheduleType,
                color: myColor,
                status: element.status
            };

            evtArray.push(a);
        });

        setLocalEvents(evtArray);

    }, [baseImage, email, defaultView, labEvents]);

    const handleSelect = ({ title, start, end, color }) => {
        if (!isSubmitted) {
            setDtStartEvent(start);
            setDtEndEvent(end);
            setInitialDtStartEvent(start);
            setInitialDtEndEvent(end);
            color === "red" ? setscheduleType("easy") : setscheduleType("web");
            settitleEvent(title);
            setShowModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleDeleteModal = () => {
        const localLabEvents = localEvents;
        const dbEvents = [];

        const newLocalLabEvents = localLabEvents.filter(function (value) {
            return !(value.start.getTime() === dtStartEvent.getTime() &&
                value.end.getTime() === dtEndEvent.getTime() &&
                value.scheduleType === scheduleType);
        });

        newLocalLabEvents.forEach((localEvent) => {
            var dbEvent = {
                teacher: { email: localEvent.teacher },
                start: localEvent.start,
                end: localEvent.end,
                status: 'pending',
                scheduleType: localEvent.scheduleType,
            };
            dbEvents.push(dbEvent);
        });

        setLabEvents(dbEvents);
        setLocalEvents(newLocalLabEvents);
        setIsSubmitble(true);
        setShowModal(false);
    };

    const handleSaveModal = () => {
        const dbEvents = [];

        const newLocalEvents = localEvents.filter(function (value) {
            return !(value.start.getTime() === dtInitialStartEvent.getTime() &&
                value.end.getTime() === dtInitialEndEvent.getTime() &&
                value.scheduleType === scheduleType);
        });

        var event = {
            title: titleEvent,
            start: dtStartEvent,
            status: 'pending',
            end: dtEndEvent,
            teacher: email,
            scheduleType: scheduleType,
        };

        newLocalEvents.push(event);
        setLocalEvents(newLocalEvents);

        newLocalEvents.forEach((localEvent) => {
            dbEvents.push({
                teacher: { email: localEvent.teacher },
                start: localEvent.start,
                end: localEvent.end,
                status:
                    localEvent.start.getTime() === event.start.getTime() &&
                    localEvent.end.getTime() === event.end.getTime() &&
                    localEvent.scheduleType === event.scheduleType
                        ? 'pending'
                        : localEvent.status,
                scheduleType: localEvent.scheduleType,
            });
        });

        setLabEvents(dbEvents);
        setIsSubmitble(true);
        setShowModal(false);
    };

    const EventDialog = () => (
        <Dialog
            open={showModal}
            onClose={handleCloseModal}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { borderRadius: 2 } }}
        >
            <DialogTitle sx={{
                fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                fontWeight: 700,
                color: themeColor
            }}>
                Prenotazione Virtual Lab
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <TextField
                        label="Docente"
                        value={email || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Laboratorio"
                        value={baseImage.imageDes || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mt: 1 }}>
                        Definizione evento
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                Inizio
                            </Typography>
                            <DatePicker
                                selected={dtStartEvent}
                                onChange={date => setDtStartEvent(date)}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="dd/mm/yyyy HH:mm"
                                locale="it"
                                inline
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                Fine
                            </Typography>
                            <DatePicker
                                selected={dtEndEvent}
                                onChange={date => setDtEndEvent(date)}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="dd/mm/yyyy HH:mm"
                                locale="it"
                                inline
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button
                    onClick={handleDeleteModal}
                    variant="outlined"
                    sx={{
                        color: '#666',
                        borderColor: '#ccc',
                        '&:hover': { borderColor: '#999', backgroundColor: '#f5f5f5' }
                    }}
                >
                    Elimina
                </Button>
                <Button
                    onClick={handleSaveModal}
                    variant="contained"
                    sx={{
                        backgroundColor: themeColor,
                        '&:hover': { backgroundColor: '#8a1830' }
                    }}
                >
                    Inserisci prenotazione
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <React.Fragment>
            <Typography
                variant="h6"
                sx={{
                    fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                    fontWeight: 600,
                    mb: 2
                }}
            >
                Pianificazione
            </Typography>
            <EventDialog />
            <Calendar
                selectable={!isSubmitted}
                defaultView={defaultView}
                defaultDate={defaultDate}
                scrollToTime={new Date()}
                localizer={localizer}
                events={localEvents}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 850 }}
                onSelectSlot={handleSelect}
                onSelectEvent={handleSelect}
                messages={{
                    next: "Prossimo",
                    previous: "Precedente",
                    today: "Oggi",
                    month: "Mese",
                    week: "Settimana",
                    day: "Giorno"
                }}
                eventPropGetter={event => {
                    return { style: { backgroundColor: event.color } };
                }}
            />
        </React.Fragment>
    );
}

export default SchedulerLab;
